import {Typography} from "@mui/material";
import ManIcon from "@mui/icons-material/Man";
import {makeStyles} from "@mui/styles";
import {budgetSummaryData, perPersonAmount} from "../domain/budgetSummaryMapper";


const styleSheets = makeStyles(theme => ({
	boxWithIcon: {
		display: "flex",
		flexDirection: "row"
	}
}))
const PerPersonRevenue = ({allBudgets, budgetYear, municipalityPopulation}) => {

	const classes = styleSheets();
	const summary = budgetSummaryData(allBudgets, budgetYear);

	return (<>
		<div className={classes.boxWithIcon}>
			<div>
				<ManIcon sx={{fontSize: 80}} color="primary"/>
			</div>
			<div>
				<Typography color="primary">
								<span
									style={{color: "#333333"}}>Revenue Budget </span> {perPersonAmount(summary.budgetedRevenueExpenditure, municipalityPopulation)}
				</Typography>
				<Typography color="primary">
								<span
									style={{color: "#333333"}}>Capital Budget </span>{perPersonAmount(summary.budgetedCapitalExpenditure, municipalityPopulation)}
				</Typography>
			</div>
		</div>
	</>)

}
export default PerPersonRevenue;
